import types from "./types";
import { ThunkDispatch } from "redux-thunk";
import api from "constants/api";
import portalManagerApi from "constants/portalManagerApi";
import _get from "lodash/get";

export const getHelpCenterLinks =
  (companyId: string, page: string, type: string) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    companyId = companyId === "BA" ? "BAIPA" : companyId;

    dispatch({ type: types.GET_HELP_CENTER_LINKS_REQUEST, payload: companyId });

    return api.app.helpCenter
      .getHelpCenterLinks(companyId, page, type)
      .then((res: any[]) => {
        dispatch({
          type: types.GET_HELP_CENTER_LINKS_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_HELP_CENTER_LINKS_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };

export const getHelpCenterLinksFromPortalManager =
  (page: string, type: string) => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.GET_HELP_CENTER_LINKS_REQUEST });

    return portalManagerApi.helpCenter
      .getHelpCenterLinks(page, type)
      .then((res: any[]) => {
        dispatch({
          type: types.GET_HELP_CENTER_LINKS_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_HELP_CENTER_LINKS_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };
